import { render, staticRenderFns } from "./account.vue?vue&type=template&id=21a06f6c&scoped=true&"
import script from "./account.vue?vue&type=script&lang=ts&"
export * from "./account.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a06f6c",
  null
  
)

export default component.exports